import { Card, Colors } from '@amelio/ui-library';

import { Bone, Skeleton } from '@/components/Skeleton/Skeleton';

/**
 * Reusable TemplateCard Skeleton Component
 * Used across multiple components for consistent loading states
 */
export const TemplateCardSkeleton = () => (
    <Skeleton>
        <Card
            borderColor={Colors.WHITE}
            borderRadius={'2xl'}
            className={'h-full'}
        >
            <Bone className={'h-16 w-16 rounded-md p-4'} />

            <Bone className={'mt-4 h-6 w-3/4'} />

            <Bone className={'mt-2 h-4 w-1/2'} />

            <div className={'mt-8 flex w-full items-center justify-between gap-4'}>
                <Bone className={'h-6 w-20 rounded-full'} />

                <Bone className={'h-8 w-16 rounded'} />
            </div>
        </Card>
    </Skeleton>
);
